import React from 'react';

import CBMediaQuery from '../../shared/CBMediaQuery';

import { formatDate, getStyle } from '../../../utils/utils';

class UserListItem extends React.Component {
  render() {
    const {
      user, onEditClick
    } = this.props;

    return (
      <CBMediaQuery>
        {screenSize => (
          <tr>
            {
              screenSize === 'large' && (
                <td style={getStyle(screenSize, styles, 'tableValueText')}>{user.id}</td>
              )
            }
            <td style={getStyle(screenSize, styles, 'tableValueText')}>{user.profile && user.profile.first_name}</td>
            <td style={getStyle(screenSize, styles, 'tableValueText')}>{user.profile && user.profile.last_name}</td>
            <td style={getStyle(screenSize, styles, 'tableValueText')}>{user.email}</td>
            {
              screenSize === 'large' && (
                <td style={getStyle(screenSize, styles, 'tableValueText')}>{formatDate(user.last_login)}</td>
              )
            }
            <td style={getStyle(screenSize, styles, 'tableValueText')}>
              <img
                alt='Options'
                src='/img/icon_edit.svg'
                style={getStyle(screenSize, styles, 'editButton')}
                onClick={() => onEditClick(user)}
              />
            </td>
          </tr>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    tableValueText: {
      fontFamily: 'TitilliumWeb-Light',
      fontSize: 18,
      color: '#FFFFFF',
    },
    editButton: {
      cursor: 'pointer',
      width: 20,
      height: 20,
    },
  },
};

export default UserListItem;
